<template>
    <detailTemplate :classCustom="[tabHistory ? 'detailShowHistory' : '', 'detail-docs']">
      <template #content>
        <i
          @click="backListPage"
          class="back-icon border-radius fal fa-arrow-right"
        />
        <div class="header">
          <div class="docTags">
            <el-tag
              v-if="outgoingDoc.docTypeName"
              class="priority lv3"
              size="mini"
            >
              {{ outgoingDoc.docTypeName }}
            </el-tag>
            <el-tag
              v-if="outgoingDoc.priorityId"
              :class="['priority', `${getPriorityClass(outgoingDoc.priorityId)}`]"
              size="mini"
            >
              <i class="fas fa-bolt"></i>
              {{ outgoingDoc.priorityName }}
            </el-tag>
          </div>
        </div>

        <VuePerfectScrollbar :settings="settings" class="scroll-area">
          <div class="body detailDocEditable">
            <div class="blkDocCreation padding-0">
              <div :class="['padding-0', 'form-info']">
                <!--form-->
                <div class="form">
                  <el-form
                    ref="form"
                    :model="form"
                    :rules="validationRules"
                  >
                    <!-- Trích yếu văn bản -->
                    <el-form-item
                      class="input-no__label input-header__docs margin-top-10"
                      prop="quote"
                    >
                      <el-input
                        type="textarea"
                        :row="3"
                        autosize
                        v-focus="true"
                        :resize="'none'"
                        v-model="form.quote"
                        placeholder="* Trích yếu văn bản"
                        maxlength="2000"
                        size="large"
                        class="input-font__bold style-fullWidth docBigTitle"
                      />
                    </el-form-item>

                    <!-- Thông tin văn bản -->
                    <div class="group__info padding-bottom-10">
                      <div class="title font-size__medium">
                        Thông tin văn bản
                      </div>

                      <div class="content">
                        <!-- <div class="label font-size__medium"></div> -->
                        <div class="form-input">
                          <div class="file-uploaded input-none__border flex-row">
                            <div class="file-uploaded" v-if="vbAttachmentPdf">
                              <div class="file clickable flex-row flex__between">
                                <a
                                  v-openInNewTab
                                  :href="getToken(vbAttachmentPdf.id) | buildAttachmentURL({
                                        type: DOWNLOAD_OPTION.TYPE.ORIGINAL
                                      })"
                                  class="flex-row flex__left"
                                >
                                  <fileTypeImage
                                    :fileExtention="vbAttachmentPdf.fileExtention"
                                    :customClass="'icon-small margin-right-10'"
                                  />
                                  <span class="fileName font-weight_normal">{{
                                      vbAttachmentPdf.fileName
                                    }}</span>
                                </a>
                                <i
                                  class="el-icon-circle-close margin-left-10 font-size__large color__red"
                                  @click="removeUploadAttachment"
                                ></i>
                              </div>
                            </div>

                            <div class="file-uploaded margin-left-10" v-if="vbAttachmentDocx">
                              <div class="file clickable flex-row flex__between">
                                <a
                                  v-openInNewTab
                                  :href="getToken(vbAttachmentDocx.id) | buildAttachmentURL({
                                        type: DOWNLOAD_OPTION.TYPE.ORIGINAL
                                      })"
                                  class="flex-row flex__left"
                                >
                                  <fileTypeImage
                                    :fileExtention="vbAttachmentDocx.fileExtention"
                                    :customClass="'icon-small margin-right-10'"
                                  />
                                  <span class="fileName font-weight_normal">{{
                                      vbAttachmentDocx.fileName
                                    }}</span>
                                </a>
                                <i
                                  class="el-icon-circle-close margin-left-10 font-size__large color__red"
                                  @click="removeUploadAttachmentDocx"
                                ></i>
                              </div>
                            </div>
                          </div>

                          <div
                            v-if="isUploadingFlagEnable">
                            <el-upload
                              class="upload-demo style-fullWidth input-border__bottom input-border__radius__0"
                              drag
                              :action="uploadAttachmentURL"
                              size="mini"
                              :on-success="
                                response =>
                                  onUploadSuccess(response).then(response =>
                                    uploadAttachmentSuccess(response)
                                  )
                              "
                              :data="uploadAttachmentAdditionalData"
                              :file-list="form.attachmentFiles"
                              :show-file-list="false"
                              :headers="uploadAttachmentHeaders"
                              accept="application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                              :before-upload="
                                file =>
                                  newValidateUploadFile(
                                    file,
                                    {
                                      acceptFileTypes: file.type
                                    },
                                    buildMessageUploadOnlyPdf()
                                  )
                              "
                              :on-error="onUploadError"
                              :on-change="() => (isUploadingDocFlag = true)"
                              v-loading="isUploadingDocFlag && isUploading"
                            >
                              <div class="el-upload__text">
                                <p class="margin-0 padding-0">
                                  Tải file đính kèm
                                  <span class="font-italic font-size__small color__red">(Định dạng file pdf,docx)</span>
                                </p>
                                <i class="fas fa-cloud-upload color__blue font-size__large"/>
                              </div>
                            </el-upload>
                          </div>

                          <div>
                            <div class="flex-row">
                              <el-button
                                class="btnPlain margin-top-5"
                                @click="openCreateTemplateFile"
                                v-if="!id && !(vbAttachmentPdf&&vbAttachmentPdf.id)"
                              >
                                <i :class="['fas fa-file-word']"></i>
                                &nbsp;Soạn thảo
                              </el-button>
                              <el-button
                                v-if="!(vbAttachmentPdf&&vbAttachmentPdf.id)"
                                class="btnPlain"
                                @click="isOpenScanDialog=true"
                              >
                                <i :class="['fas fa-search']"></i>
                                &nbsp;Scan
                              </el-button>
                              <el-button class="btnPlain" v-if="vbAttachmentDocx">
                                <i :class="['fas fa-edit']" style="position: relative;top: -10px;"></i>
                                <iframe v-if="wordEditSrc" :src="wordEditSrc" width="50" height="36"
                                        style='border: none;overflow:hidden;' frameborder="0"></iframe>
                              </el-button>
                              <el-button class="btnPlain" @click="isOpenVbDiVersionDialog = true"
                                         v-if="vbAttachmentPdf&&vbAttachmentPdf.id">
                                <i class="fas fa-mouse-pointer"></i>
                                &nbsp;Phiên bản văn bản dự thảo
                              </el-button>
                            </div>
                          </div>

                          <el-form-item class="custom-label__input margin-top-10">
                            <span class="label-input">Loại văn bản: </span>
                            <el-select
                              clearable
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="form.docTypeId"
                              filterable
                              disabled
                              placeholder="-"
                              @change="docTypeChange"
                            >
                              <el-option
                                v-for="item in docTypes"
                                :key="item.id"
                                :label="item.categoryName"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item class="custom-label__input">
                            <span class="label-input">Độ khẩn: </span>
                            <multiselect
                              :class="[
                                form.priorityId ? '' : '',
                                'style-fullWidth input-font__bold',
                                'input-border__radius__0'
                              ]"
                              :options="priorities"
                              label="categoryName"
                              track-by="id"
                              :preselect-first="true"
                              v-model="priority"
                              :custom-label="customLabelPriority"
                              placeholder="-"
                              :multiple="false"
                              :close-on-select="true"
                              :clear-on-select="true"
                              :searchable="true"
                              open-direction="top"
                            >
                              <template slot="noResult"
                              >Không tìm thấy dữ liệu phù hợp.
                              </template>
                              <template slot="noOptions"
                              >Danh sách trống
                              </template>
                              <template slot="singleLabel" slot-scope="{ option }">
                                <el-tag
                                  size="medium"
                                  :class="[
                                    'priority',
                                    option.categoryName === 'Hỏa tốc' ? 'lv1' : '',
                                    option.categoryName === 'Khẩn' ? 'lv2' : '',
                                    option.categoryName === 'Bình thường' ? 'lv3' : ''
                                  ]"
                                >
                                  {{ option.categoryName }}
                                </el-tag>
                              </template>
                            </multiselect>
                          </el-form-item>

                          <el-form-item class="custom-label__input">
                            <span class="label-input">Hạn xử lý: </span>
                            <el-date-picker
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="form.deadlineDate"
                              type="datetime"
                              :prefix-icon="' '"
                              placeholder="dd/mm/yyyy"
                              default-time="17:30:00"
                              format="dd/MM/yyyy HH:mm"
                            ></el-date-picker>
                          </el-form-item>

                          <el-form-item class="custom-label__input" prop="publisherId">
                            <span class="label-input field-needed">Đơn vị ban hành </span>
                            <el-select
                              filterable
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="form.publisherId"
                              placeholder="-"
                              disabled
                              clearable
                              @change="publisherIdChange"
                            >
                              <el-option
                                v-for="item in publisherDepartments"
                                :label="item.deptName"
                                :key="item.id"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item
                            class="custom-label__multiple__element"
                            prop="numberOfPage"
                          >
                            <span class="label-input">Số trang: </span>
                            <el-input-number
                              size="mini"
                              class="style-fullWidth input-font__bold"
                              v-model="form.numberOfPage"
                              placeholder="-"
                              :controls="true"
                              :min="0"
                              :step="1"
                              :precision="0"
                              :max="1000"
                            >
                            </el-input-number>
                          </el-form-item>

                          <el-form-item class="custom-label__input">
                            <span class="flex-row flex__right label-input">
                              Nơi nhận bên trong &nbsp;
                              <el-tooltip
                                content="Cây danh mục đơn vị"
                                placement="top"
                                effect="dark"
                              >
                                <i
                                  class="fas fa-cog advance-search color__cyan clickable"
                                  @click="isOpenSelectDepartmentDialog = true"
                                ></i>
                              </el-tooltip>
                            </span>
                            <el-select
                              filterable
                              clearable
                              v-model="form.receiveDepartmentIds"
                              multiple
                              size=""
                              placeholder="Nhập tên đơn vị để tìm kiếm"
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                            >
                              <el-option
                                v-for="item in receiveDepartments"
                                :label="customDeptName(item)"
                                :key="item.id"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>

                          <el-form-item
                            prop="otherReceivePlaces"
                            class="custom-label__input"
                          >
                            <span class="label-input">Nơi nhận bên ngoài: </span>
                            <el-select
                              v-model="otherReceiverPlace"
                              multiple
                              filterable
                              allow-create
                              default-first-option
                              remote
                              reserve-keyword
                              :remote-method="remoteMethod"
                              :loading="isLoading"
                              class="style-fullWidth input-border__bottom input-border__radius__0"
                            >
                              <el-option
                                v-for="(item, index) in listOtherReceiverPlace"
                                :key="index"
                                :label="item.deptName"
                                :value="item.deptName"
                              >
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item
                            class="custom-label__input margin-top-10"
                            v-if="isBanHanhTrucLienThong"
                            prop="steeringTypeId"
                          >
                            <span :class="['label-input', 'field-needed']">Loại chỉ đạo</span>
                            <el-select
                              clearable
                              class="style-fullWidth input-font__bold input-border__bottom input-border__radius__0"
                              v-model="form.steeringTypeId"
                              filterable
                              placeholder="-"
                            >
                              <el-option
                                v-for="item in steeringTypes"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              />
                            </el-select>
                          </el-form-item>
                        </div>
                      </div>
                    </div>
                  </el-form>

                  <doc-relations-form
                    :title="'Văn bản liên quan không ban hành kèm'"
                    :attachedType="DOC_RELATION_ATTACHED_TYPE.NO_ATTACHED"
                    :docId="id"
                    ref="noAttachedDocRelationsForm"
                  ></doc-relations-form>

                  <doc-relations-form
                    :title="'Văn bản liên quan ban hành kèm'"
                    :attachedType="DOC_RELATION_ATTACHED_TYPE.ATTACHED"
                    :docId="id"
                    ref="attachedDocRelationsForm"
                  ></doc-relations-form>

                  <phieu-y-kien-form
                    v-if="showTTrTable"
                    :title="'Phiếu ý kiến'"
                    :docId="id"
                    :categoryCode="categoryCode"
                    ref="phieuYKienForm"
                  ></phieu-y-kien-form>

                  <vbdi-luongxuly-wrapper :id="id"></vbdi-luongxuly-wrapper>
                </div>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>

        <div v-if="!isAchievement" class="footer">
          <div class="flex-row flex__left form-button__action">
            <!--          h start cây thư mục-->
            <el-button
              class="detailBtn detailBtnPrimary"
              @click="linkFolder"
            >
              <i class="fas fa-link"></i>
              Liên Kết Thư Mục
            </el-button>
            <!--          h end cây thư mục-->
            <el-button
              v-if="isEnableChuyenXuLi() && !isViewAsUyQuyen"
              class="detailBtn detailBtnPrimary"
              @click="openChuyenXuLyLuongMoiDialog"
            >
              <i class="fas fa-arrow-alt-to-right font-size__small"></i>
              <span v-if="step == null || step.signType != 2"
              >&nbsp;Chuyển phê duyệt</span
              >
              <span v-else-if="step && step.signType == 2"
              >&nbsp;Ký số và Chuyển xử lý</span
              >
            </el-button>
            <el-button
              class="dialogBtnPrimary"
              @click="saveDoc()"
              :disabled="isProcessing"
            >
              <i :class="[!isProcessing ? 'fas fa-save' : 'el-icon-loading']"></i>
              &nbsp;Lưu
            </el-button>
            <el-button
              v-if="isEnableKetThuc() && !isViewAsUyQuyen"
              class="detailBtn detailBtnSecondary"
              @click="openKetThucDialog"
            >
              <i class="fas fa-check-circle font-size__small"></i>
              <span v-if="step == null || step.signType != 2"
              >&nbsp;Phê duyệt</span
              >
              <span v-else-if="step && step.signType == 2">&nbsp;Ký duyệt</span>
            </el-button>
            <el-button
              class="detailBtn detailBtnPrimary "
              @click="inPhieuTrinhKi"
            >
              <i class="fas fa-print"></i>
              In phiếu xử lý
            </el-button>

            <el-button
              v-if="isChoXuLy() && !isViewAsUyQuyen"
              class="detailBtn detailBtnAlert"
              @click="tuChoi()"
            >
              <i class="fas fa-ban font-size__small"></i>
              &nbsp;Từ chối
            </el-button>

            <el-button
              v-if="isEnableTuChoiBanHanh()"
              class="detailBtn detailBtnAlert"
              @click="tuChoiBHanh()"
            >
              <i class="fas fa-ban font-size__small"></i>
              &nbsp;Từ chối
            </el-button>

            <el-button
              v-if="canOutGoingProcessThuHoi && !isViewAsUyQuyen"
              class="detailBtn detailBtnSecondary"
              @click="isOpenOutgoingDocProcessThuHoiDialog = true"
            >
              <i class="fas fa-undo font-size__small"></i>
              &nbsp;Thu hồi
            </el-button>

            <el-button
              v-if="canOutoingDocThuHoi"
              class="detailBtn detailBtnSecondary"
              @click="isOpenOutgoingDocThuHoiDialog = true"
            >
              <i class="fas fa-undo font-size__small"></i>
              &nbsp;Thu hồi
            </el-button>

            <el-button
              v-if="canOutoingDocDBHThuHoi"
              class="detailBtn detailBtnSecondary"
              @click="isOpenOutgoingDocDBHThuHoiDialog = true"
            >
              <i class="fas fa-undo font-size__small"></i>
              &nbsp;Thu hồi
            </el-button>

            <el-button
              v-if="isEnableBanHanh()"
              class="detailBtn detailBtnPrimary"
              @click="isOpenBHanhDocOut = true"
            >
              <i class="fas fa-file-export font-size__small"></i>
              &nbsp;Ban hành
            </el-button>

            <el-button
              v-if="isEnableSuaSaiBanHanh()"
              class="detailBtn detailBtnPrimary"
              @click="suaSaiBanHanh"
            >
              <i class="fas fa-check font-size__small"></i>
              Sửa sai
            </el-button>

            <el-button
              v-if="isEnableHieuChinh()"
              class="detailBtn detailBtnPrimary"
              @click="hieuChinhVb()"
            >
              <i class="fas fa-file-export font-size__small"></i>
              &nbsp;Hiệu chỉnh & ban hành
            </el-button>

            <el-button
              v-if="isEnableDelete()"
              class="detailBtn btn__delete btn-none__border color__white bg__red"
              @click="delete_()"
            >
              <i class="fas fa-trash font-size__small"></i>&nbsp; Xóa văn bản
            </el-button>
            <el-button
              v-if="isEnableCC()"
              class="detailBtn detailBtnSecondary"
              @click="openCCDialog()"
            >
              <i class="fas fa-share-all font-size__small"></i>
              &nbsp;CC
            </el-button>

            <el-button
              v-if="isEnableExportTiepNhanVanBanReport"
              class="detailBtn detailBtnPrimary"
              @click="exportTiepNhanVanBanReport"
            >
              <i class="fas fa-fast-forward font-size__small"></i>
              Báo cáo tiếp nhận
            </el-button>
          </div>

          <div class="flex-row flex__right">
            <listIconAction :docId="id"/>
          </div>
        </div>
        <div v-else class="footer">
          <div class="flex-row flex__left form-button__action">
            <el-button class="detailBtn detailBtnPrimary" @click="restore">
              <i class="fas fa-undo font-size__small"></i>
              Phục hồi
            </el-button>

            <el-button class="detailBtn detailBtnAlert" @click="permanentDelete">
              <i class="fas fa-trash font-size__small"></i>
              Xóa văn bản
            </el-button>
          </div>
        </div>

        <transition name="slide">
          <history-docout
            v-show="tabHistory"
            :isEnableComment="true"
            :vbOutgoingDocId="id"
            @closeHistory="closeTabHistory"
          ></history-docout>
        </transition>

        <!-- dialog chon nguoi xu ly -->
        <DocOutSelectHandlerLanhDao
          v-if="isEnableDocOutSelectHandlerDialog"
          :isOpen="isOpenDocOutSelectHandlerDialog"
          :outgoingProcessId="userVbOutgoingProcessId"
          :quote="outgoingDoc.quote"
          :vbAttachmentDocx="vbAttachmentDocx"
          :vbAttachmentPdf="vbAttachmentPdf"
          :convertToSubmitForm="convertToSubmitForm"
          @closeDialog="isOpenDocOutSelectHandlerDialog = false"
          @closed="isEnableDocOutSelectHandlerDialog = false"
          @success="chuyenXuLiSuccess"
        />

        <!-- dialog ket thuc -->
        <DocOutKetThucLanhDao
          v-if="isEnableDocOutKetThucDialog"
          :docId="id"
          :isOpen="isOpenDocOutKetThucDialog"
          :vbOutgoingProcessId="userVbOutgoingProcessId"
          @closeDialog="isOpenDocOutKetThucDialog = false"
          @dialogClosed="isEnableDocOutKetThucDialog = false"
          @success="banHanhSuccess"
        />

        <outgoingDocThuHoiDialog
          v-if="isEnableOutgoingDocThuHoiDialog"
          :isOpen="isOpenOutgoingDocThuHoiDialog"
          :vbOutgoingDocId="id"
          @closeDialog="isOpenOutgoingDocThuHoiDialog = false"
          @dialogClosed="isEnableOutgoingDocThuHoiDialog = false"
        />
        <!-- dialog tu choi -->

        <DocOutTuChoi
          v-if="isEnableDocOutTuChoiDialog"
          :docId="id"
          :isOpen="isOpenDocOutTuChoiDialog"
          :listImageChange="listImageChange"
          :outgoingProcessId="userVbOutgoingProcessId"
          @closeDialog="isOpenDocOutTuChoiDialog = false"
          @closed="isEnableDocOutTuChoiDialog = false"
          @tuChoiSuccess="tuChoiSuccess"
        />
        <!-- dialog tu choi -->

        <DocOutTuChoiBanHanh
          v-if="isEnableDocOutTuChoiBHanhDialog"
          :docId="id"
          :isOpen="isOpenDocOutTuChoiBHanhDialog"
          @closeDialog="isOpenDocOutTuChoiBHanhDialog = false"
          @closed="isEnableDocOutTuChoiBHanhDialog = false"
          @tuChoiSuccess="tuChoiBHanhSuccess"
        />

        <!-- ban hành văn bản -->
        <BHanhDocOutDialog
          v-if="isEnableBHanhDocOut"
          :deptEditorId="outgoingDoc.deptEditorId"
          :docId="id"
          :docReceiverIds="docReceiverIds"
          :docStatus="outgoingDoc.status"
          :docTypeId="outgoingDoc.docTypeId"
          :isOpen="isOpenBHanhDocOut"
          :otherReceivePlaces="outgoingDoc.otherReceivePlaces"
          :publisherId="outgoingDoc.publisherId"
          :quote="outgoingDoc.quote"
          @closeDialog="isOpenBHanhDocOut = false"
          @closed="isEnableBHanhDocOut = false"
          @success="banHanhVanThuSuccess"
        />

        <!-- CC văn bản -->
        <CCDocOut
          v-if="isEnableDocOutCCDialog"
          :docId="id"
          :docTitle="outgoingDoc.quote"
          :isOpen="isOpenDocOutCCDialog"
          @closeDialog="isOpenDocOutCCDialog = false"
          @closed="isEnableDocOutCCDialog = false"
          @success="ccSuccess"
        />

        <outgoingDocProcessThuHoiDialog
          v-if="isEnableOutgoingDocProcessThuHoiDialog"
          :isOpen="isOpenOutgoingDocProcessThuHoiDialog"
          :vbOutgoingProcessId="userVbOutgoingProcessId"
          @closeDialog="isOpenOutgoingDocProcessThuHoiDialog = false"
          @dialogClosed="isEnableOutgoingDocProcessThuHoiDialog = false"
          @success="outGoingProcessThuHoiSuccess"
        />

        <outgoingDocThuHoiDialog
          v-if="isEnableOutgoingDocThuHoiDialog"
          :isOpen="isOpenOutgoingDocThuHoiDialog"
          :vbOutgoingDocId="id"
          @closeDialog="isOpenOutgoingDocThuHoiDialog = false"
          @dialogClosed="isEnableOutgoingDocThuHoiDialog = false"
        />

        <outgoingDocDBHThuHoiDialog
          v-if="isEnableOutgoingDocDBHThuHoiDialog"
          :isOpen="isOpenOutgoingDocDBHThuHoiDialog"
          :vbOutgoingDocId="id"
          @closeDialog="isOpenOutgoingDocDBHThuHoiDialog = false"
          @closed="isEnableOutgoingDocDBHThuHoiDialog = false"
        />
        <!--note in doc-->
        <DialogNoteInDocs
          v-if="isOpenNoteInDocDialog"
          :docId="id"
          :isAddSignature="false"
          :isOpen="isOpenNoteInDocDialog"
          :isWatchingNote="false"
          :vbAttachmentId="vbAttachmentPdf.id"
          @closeDialog="isOpenNoteInDocDialog = false"
          @closed="isEnableNoteInDocDialog = false"
          @finishNoteDoc="finishNoteDoc"
        />
        <!--add chu ky-->
        <DialogNoteInDocs
          v-if="isOpenAddSignatureDialog"
          :docId="id"
          :isAddSignature="true"
          :isOpen="isOpenAddSignatureDialog"
          :isWatchingNote="false"
          :vbAttachmentId="vbAttachmentPdf.id"
          @addSignatureSuccess="addSignatureSuccess"
          @closeDialog="isOpenAddSignatureDialog = false"
          @closed="isEnableAddSignatureDialog = false"
        />

        <task-create-dialog
          v-if="isEnableCreateJobDialog"
          :docId="id"
          :docType="DOC_TYPE.VB_DI"
          :isOpen="isOpenCreateJobDialog"
          :taskType="TASK_TASK_TYPE.GIAOVIEC"
          :viewType="JOB_INDEX_PAGE.ASSIGNER"
          @closeDialog="isOpenCreateJobDialog = false"
          @dialogClosed="isEnableCreateJobDialog = false"
          @success="createTaskSuccess"
        />

        <vb-outgoing-doc-sua-sai-bh-dialog
          v-if="isEnableSuaSaiDialog"
          :id="id"
          :isOpen="isOpenSuaSaiDialog"
          @closeDialog="isOpenSuaSaiDialog = false"
          @dialogClosed="isEnableSuaSaiDialog = false"
          @updateSuccess="suaSaiSuccess"
        >
        </vb-outgoing-doc-sua-sai-bh-dialog>
        <!--    hoang  cây thư mục start-->
        <tree-folder-dialog
          v-if="isEnableTreeFolderDialog"
          :accessoryType="accessoryType"
          :isOpen="isOpenDialogCreate"
          :vbId="id"
          @closeDialog="closeTreeFolderDialog"
          @closed="isEnableTreeFolderDialog"
          @success="createSuccess"
        />
        <!--   hoang   cây thư mục end-->
        <vbdi-list-version-lanh-dao-edit-dialog
          :docId="id"
          :isOpen="isOpenVbDiVersionDialog"
          :mode="mode"
          :title="'Phiên bản văn bản soạn thảo'"
          @closeDialog="isOpenVbDiVersionDialog=false"
        >
        </vbdi-list-version-lanh-dao-edit-dialog>

        <selectDepartmentDialog
          :isOpen="isOpenSelectDepartmentDialog"
          :multipleSelect="true"
          :publisherId="form.publisherId"
          :receiveDepartmentIds="form.receiveDepartmentIds"
          v-if="isEnableSelectDepartmentDialog"
          @closed="isEnableSelectDepartmentDialog = false"
          @closeDialog="isOpenSelectDepartmentDialog = false"
          @change="publisherDepartmentChange"
        />

      </template>
    </detailTemplate>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../constants";
import {EventBus} from "../../event-bus.js";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import convertToLabelFilter from "../../filters/convertToLabelFilter";
import dateFormatter from "../../filters/dateFormatter";
import errorMessageFilter from "../../filters/errorMessageFilter";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import attachmentService from "../../services/attachmentService";
import categoryViewService from "../../services/categoryViewService";
import h from "../../services/h";
import outgoingDocService from "../../services/outgoingDocService";
import utils from "../../services/utils";
import vbAttachmentTokenService from "../../services/vbAttachmentTokenService";
import vbDelegateInfoService from "../../services/vbDelegateInfoService";
import vbFlowInstanceService from "../../services/vbFlowInstanceService.js";
import vbOutgoingDocReceiversService from "../../services/vbOutgoingDocReceiversService";
import vbOutgoingProcessService from "../../services/vbOutgoingProcessService.js";
import vbStepService from "../../services/vbStepService";
import BreakWordSpan from "../adminstration/ketluan/break-word-span";
import FileTypeImage from "../common/FileTypeImage";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import TaskCreateDialog from "../job/create-job/task-create-dialog";
import BHanhDocOutDialog from "./components/BHanhDocOutDialog";
import CCDocOut from "./components/CCDocOut";
import DocOutKetThucLanhDao from "./components/DocOutKetThucLanhDao";
import DocOutTuChoi from "./components/DocOutTuChoi";
import DocOutTuChoiBanHanh from "./components/DocOutTuChoiBHanh";
import DocRelationsDetail from "./doc-relations-detail";
import HistoryDocout from "./History";
import VbOutgoingDocSuaSaiBhDialog from "./vb-outgoing-doc-sua-sai-bh-dialog";
import VbdiDownloadFiles from "./vbdi-download-files";
import VbdiLuongxulyWrapper from "./vbdi-luongxuly-wrapper";
import CreateJobDialog from "../job/create-job/dialog-create";
import VbdiListVersionLanhDaoEditDialog from "./vbdi-list-version-lanh-dao-edit-dialog";
import authenService from "../../services/authenService";
import uploadFileMixin from "../doc-in/uploadFileMixin";
import departmentService from "../../services/departmentService";
import flowService from "../../services/flowService";
import nextStepInfoViewService from "../../services/nextStepInfoViewService";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import otherDepartmentService from "../../services/otherDepartmentService";
import DocRelationsForm from "./doc-relations-form";
import dateUtils from "../../dateUtils";
import outgoingDocReceiversService from "../../services/outgoingDocReceiversService";
import Vue from "vue";
import PhieuYKienForm from "./phieu-ykien-form";
import outgoingDocVersionService from "../../services/outgoingDocVersionService";

export default {
  mixins: [handleRequestErrorMixin, vbAttachmentTokenMixin, uploadFileMixin],
  components: {
    VbdiListVersionLanhDaoEditDialog,
    BreakWordSpan,
    VbOutgoingDocSuaSaiBhDialog,
    TaskCreateDialog,
    HistoryDocout,
    VbdiLuongxulyWrapper,
    DocRelationsDetail,
    DocRelationsForm,
    PhieuYKienForm,
    VbdiDownloadFiles,
    CreateJobDialog,
    FileTypeImage,
    DocOutSelectHandlerLanhDao: () => import("./components/DocOutSelectHandlerLanhDao.vue"),
    DocOutKetThucLanhDao,
    DocOutTuChoi,
    DocOutTuChoiBanHanh,
    BHanhDocOutDialog,
    CCDocOut,
    detailTemplate: () => import("../common/detail.vue"),
    outgoingDocProcessThuHoiDialog: () =>
      import("./components/outgoingDocProcessThuHoiDialog"),
    outgoingDocThuHoiDialog: () =>
      import("./components/outgoingDocThuHoiDialog"),
    outgoingDocDBHThuHoiDialog: () =>
      import("./components/thuhoiBanHanhdialog"),
    VuePerfectScrollbar,
    listIconAction: () => import("./components/listIconActionDocs.vue"),
    DialogNoteInDocs: () => import("../common/noteDocs/index"),
    treeFolderDialog: () => import("../setting/quanLyTaiLieu/treeFolderDialog"),
    selectDepartmentDialog: () => import("./components/selectDepartmentDialog")
  },

  filters: {dateFormatter, buildAttachmentURL, convertToLabelFilter},

  data() {
    return {
      // h- start
      mode: 'Edit',
      isOpenVbDiVersionDialog: false,
      // vbIngoingDocCopy: null,
      // vbOutgoingDocCopy: null,
      isOpenDialogCreate: false,
      isEnableTreeFolderDialog: true,
      accessoryType: constants.QUAN_LY_TAI_LIEU.VB_DI,
      vbId: null,
      vbType: null,
      steeringTypeLabel: null,
      isLawDocument: null,
      DOC_RELATION_ATTACHED_TYPE: constants.DOC_RELATION_ATTACHED_TYPE,
      DOC_RELATION_OBJECT_TYPE: constants.DOC_RELATION_OBJECT_TYPE,
      listImageChange: [],

      isOpenNoteInDocDialog: false,
      isEnableNoteInDocDialog: false,

      isOpenAddSignatureDialog: false,
      isEnableAddSignatureDialog: false,

      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      settings: {maxScrollbarLength: 750},
      tabHistory: true,
      docRelationTypes: [],

      outgoingDoc: {},
      vbAttachmentPdf: {},
      vbAttachmentDocx: {},
      attachmentMetadata: null,
      signatureFile: null,
      referenceOutgoingAttachment: null,
      docRelations: [],
      docReceivers: null,
      agencies: null,
      receiveOtherDepts: null,
      docReceiverIds: [],
      vbCommentObjectType: constants.COMMENT_OBJECT_TYPE.VB_DI,
      userVbOutgoingProcess: null,
      flowInstance: null,
      flowInstanceId: null,
      flowInstances: [],
      flowId: null,
      stepId: null,
      step: null,
      delegateInfo: null,

      isOpenDocOutSelectHandlerDialog: false,
      isEnableDocOutSelectHandlerDialog: false,
      isOpenDocOutKetThucDialog: false,
      isEnableDocOutKetThucDialog: false,

      isOpenDocOutTuChoiDialog: false,
      isEnableDocOutTuChoiDialog: false,

      isOpenDocOutTuChoiBHanhDialog: false,
      isEnableDocOutTuChoiBHanhDialog: false,

      isOpenDocOutCCDialog: false,
      isEnableDocOutCCDialog: false,

      isOpenOutgoingDocProcessThuHoiDialog: false,
      isEnableOutgoingDocProcessThuHoiDialog: false,
      isOpenOutgoingDocThuHoiDialog: false,
      isEnableOutgoingDocThuHoiDialog: false,
      isOpenOutgoingDocDBHThuHoiDialog: false,
      isEnableOutgoingDocDBHThuHoiDialog: false,
      isOpenBHanhDocOut: false,
      isEnableBHanhDocOut: false,
      outgoingAttachmentURL: null, //link download nguyen goc;
      outgoingAttachmentForVanThuURL: null, //link download co chu ky khong co watermark;
      referenceOutgoingAttachmentURL: null, //link download co chu ky kem watermark;
      referenceOutgoingAttachmentURL2: null, //link download trc khi ban hanh co kem watermark;

      isOpenCreateJobDialog: false,
      isEnableCreateJobDialog: false,
      TASK_TASK_TYPE: constants.TASK_TASK_TYPE,
      JOB_INDEX_PAGE: constants.JOB_INDEX_PAGE,
      // giaoViecMenuConfig: null,
      DOC_TYPE: constants.DOC_TYPE,
      OUTGOING_DOC_STATUS: constants.OUTGOING_DOC_STATUS,

      isOpenSuaSaiDialog: false,
      isEnableSuaSaiDialog: false,

      IS_PDF: constants.DOWNLOAD_OPTION.TYPE.PDF,
      IS_DOC: constants.DOWNLOAD_OPTION.TYPE.DOC,
      departments: null, // Danh sách toàn bộ các departments
      deptCode: null,
      validationRules: {},
      isProcessing: false,
      isUploadingDocFlag: null,
      isUploadingFlagEnable: false,
      wordEditSrc: null,
      // deadlineDate: null,
      docTypes: null, // List loại văn bản
      priorities: [], // List Độ khẩn
      publisherDepartments: [], // List đơn vị ban hành
      receiveDepartments: [], // List nơi nhận bên trong
      otherReceiverPlace: [], // Nơi nhận bên ngoài được chọn
      listOtherReceiverPlace: [], // List source nơi nhận bên ngoài
      priority: null,
      showTTrTable: false,
      isOpenSelectDepartmentDialog: false,
      isEnableSelectDepartmentDialog: false,
      isLoading: false,
      secretLevels: null,
      steeringTypes: null, // Loại chỉ đạo (ban hành trục liên thông),
      docVersions: [], // List các phiên bản\
      originalDocRelations: [], // List các phiên bản doc relation
      form: {
        quote: null,
        attachmentFiles: [],
        attachmentId: null,
        receiveDepartmentIds: null,
        docTypeId: null,
        docDate: null,
        deadlineDate: null,
        securityId: null,
        priorityId: null,
        numberOfCopy: null,
        numberOfPage: null,
        isLawDocument: null,
        // isAnswer: null,
        // isDirectionDocument: null,
        relationDocs: [],
        publisherId: null,
        publisherName: null,
        flow: null,
        flowId: null,
        handlerId: null,
        handlerDeptId: null,
        handlerRoleId: null,
        flowNote: null,
        stepId: null,
        docCode: null,
        incomingDate: null,
        isEnvelope: null,
        bookNumber: null,
        subBookNumber: null,
        // bookId: null,
        tltvbAgencyIds: [],
        steeringTypeId: null
      },
    };
  },

  created() {
    this.initValidationRules(constants.CREATE_DOCIN_PAGE.MODE.FOR_SAVE);

    this.deptCode = this.$route.params.deptCode;
    this.fullScreenState = false;
    // set default
    // this.deadlineDate = new Date(
    //   new Date().getTime() + 7 * 24 * 60 * 60 * 1000
    // );

    this.initSteeringTypes(); // Khởi tạo danh sách loại chỉ đạo (ban hành trục liên thông)
    this.loadCategories(); // Khởi tạo list độ khẩn, loại văn bản, ...
    this.loadPublisherDepartments(); // Khỏi tạo list đơn vị ban hành
  },

  mounted() {
    this.id && this.prepareFormForEditMode();

  },

  computed: {
    isEnableBanHanhTrucLienThong() {
      let publisher = h.find(
        this.publisherDepartments,
        item => item.id === this.form.publisherId
      );
      return publisher && publisher.agencyUuid;
    },

    uploadAttachmentAdditionalData() {
      return {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DI,
        note: ""
      };
    },

    uploadAttachmentURL() {
      return constants.BASE_SERVICE_URL + "attachment/uploadFile";
    },

    uploadAttachmentHeaders() {
      let header = {};
      let idToken = authenService.getIdToken();
      idToken && (header["Authorization"] = "Bearer " + idToken);
      // console.log("uploadFIleMixin uploadAttachmentHeaders " + idToken);
      let sessionId = authenService.getSessionId();
      sessionId && (header[constants.HTTP_HEADER_KEY.SESSION_ID] = sessionId);
      var userDeptRoleId = authenService.get(
        constants.STORAGE_KEY.USER_DEPT_ROLE_ID
      );
      userDeptRoleId &&
      (header[constants.HTTP_HEADER_KEY.USER_DEPT_ROLE_ID] = userDeptRoleId);
      return header;
    },

    //xác định xem văn bản có phải đã bị "xóa" không ?
    isAchievement() {
      return this.outgoingDoc.isAchievement;
    },

    signerName() {
      if (this.outgoingDoc) {
        return this.outgoingDoc.signerUserDeptRoleId
          ? `${this.outgoingDoc.signerName} (${
            this.outgoingDoc.signerPosName
          } ${this.outgoingDoc.signerDeptName})`
          : this.outgoingDoc.signerName;
      } else {
        return null;
      }
    },

    isKyNgoai() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.isKyNgoai === constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE
      );
    },

    userVbOutgoingProcessId() {
      return this.$route.query.vbDocProcessId;
    },

    parentRoute() {
      return this.$route.path.split("/")[3];
    },

    userId() {
      return this.$store.getters.user.id;
    },

    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },

    roleCode() {
      return this.$store.getters.userDeptRole.roleCode;
    },

    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },

    publisherId() {
      return this.outgoingDoc ? this.outgoingDoc.publisherId : null;
    },

    /**
     * có thể thu hồi bởi người thực hiện chuyển xử lý;
     * @returns {boolean|outgoingDoc|{}}
     */
    canOutGoingProcessThuHoi() {
      return (
        this.userVbOutgoingProcess &&
        this.userVbOutgoingProcess.status ==
        constants.OUTGOING_PROCESS_STATUS.DA_XU_LY &&
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DANGXULI
      );
    },

    /**
     * có thể thu thồi bởi người ban hành;
     * @returns {boolean|outgoingDoc|{}}
     */
    canOutoingDocThuHoi() {
      return (
        !this.userVbOutgoingProcessId &&
        this.outgoingDoc &&
        this.outgoingDoc.creatorId == this.userId &&
        constants.OUTGOING_DOC_STATUS.DANGXULI == this.outgoingDoc.status
      );
    },
    /**
     * thu hồi vb đã ban hành;
     * @returns {boolean|outgoingDoc|{}}
     */
    canOutoingDocDBHThuHoi() {
      return (
        this.roleCode == "vanthu" &&
        constants.OUTGOING_DOC_STATUS.DABANHANH == this.outgoingDoc.status
      );
    },

    id() {
      return this.$route.params.id;
    },

    docStatus() {
      return this.outgoingDoc ? this.outgoingDoc.status : null;
    },

    attachmenttURLForChuyenVien() {
      return [
        constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
        constants.OUTGOING_DOC_STATUS.DABANHANH
      ].indexOf(this.docStatus)
        ? this.referenceOutgoingAttachmentURL ||
        this.referenceOutgoingAttachmentURL2
        : this.referenceOutgoingAttachmentURL2;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },

    isViewAsUyQuyen() {
      return (
        this.delegateInfo &&
        this.delegateInfo.fromUserDeptRoleId == this.userDeptRoleId
      );
    },

    isEnableExportTiepNhanVanBanReport() {
      return (
        this.roleCode === constants.ROLE.CODE.VAN_THU &&
        this.outgoingDoc &&
        this.outgoingDoc.status === constants.OUTGOING_DOC_STATUS.DABANHANH
      );
    },

    isBanHanhTrucLienThong() {
      return this.agencies && this.agencies.length;
    },

    outgoingDocReceivers() {
      return h.collect(this.form.receiveDepartmentIds, item => {
        return {
          objectId: item,
          objectType: constants.RECEIVER_OBJECT_TYPE.DONVI
        };
      });
    }
  },

  watch: {
    isOpenSelectDepartmentDialog(newValue) {
      newValue && (this.isEnableSelectDepartmentDialog = newValue);
    },

    vbAttachmentDocx(newValue) {
      this.isUploadingFlagEnable = (!this.vbAttachmentDocx && !this.vbAttachmentPdf);
    },

    userVbOutgoingProcessId(newValue) {
      if (newValue) {
        this.loadUserVbOutgoingProcess();
      } else {
        this.userVbOutgoingProcess = null;
        this.flowInstanceId = null;
        this.stepId = this.userVbOutgoingProcess.stepId;
        this.step = null;
        this.flowInstance = null;
        this.flowId = null;
      }

      this.buildOutgoingAttachmentURL();
    },

    isOpenOutgoingDocProcessThuHoiDialog(newValue) {
      newValue && (this.isEnableOutgoingDocProcessThuHoiDialog = newValue);
    },
    isOpenOutgoingDocThuHoiDialog(newValue) {
      newValue && (this.isEnableOutgoingDocThuHoiDialog = newValue);
    },
    isOpenOutgoingDocDBHThuHoiDialog(newValue) {
      newValue && (this.isEnableOutgoingDocDBHThuHoiDialog = newValue);
    },
    isOpenDocOutKetThucDialog(newValue) {
      newValue && (this.isEnableDocOutKetThucDialog = newValue);
    },
    isOpenBHanhDocOut(newValue) {
      newValue && (this.isEnableBHanhDocOut = newValue);
    },
    isOpenDocOutSelectHandlerDialog(newValue) {
      newValue && (this.isEnableDocOutSelectHandlerDialog = newValue);
    },
    isOpenDocOutCCDialog(newValue) {
      newValue && (this.isEnableDocOutCCDialog = newValue);
    },
    isOpenDocOutTuChoiDialog(newValue) {
      newValue && (this.isEnableDocOutTuChoiDialog = newValue);
    },
    isOpenDocOutTuChoiBHanhDialog(newValue) {
      newValue && (this.isEnableDocOutTuChoiBHanhDialog = newValue);
    },
    isOpenNoteInDocDialog(newValue) {
      newValue && (this.isEnableNoteInDocDialog = newValue);
    },
    isOpenAddSignatureDialog(newValue) {
      newValue && (this.isEnableAddSignatureDialog = newValue);
    },
    isOpenSuaSaiDialog(newValue) {
      newValue && (this.isEnableSuaSaiDialog = newValue);
    },
    vbAttachmentPdf(newValue) {
      this.isUploadingFlagEnable = (!this.vbAttachmentDocx && !this.vbAttachmentPdf);
      this.buildOutgoingAttachmentURL();
      this.loadAttachmentMetadata();
    },
    referenceOutgoingAttachment() {
      this.buildReferenceOutgoingAttachmentURL();
      this.buildOutgoingAttachmentForVanThuURL();
    },

    id() {
      if (this.id) {
        this.prepareFormForEditMode();
      }
    },

    isOpenCreateJobDialog(newValue) {
      newValue && (this.isEnableCreateJobDialog = newValue);
    }
  },

  methods: {
    // Khởi tạo danh sách loại chỉ đạo (ban hành trục liên thông)
    initSteeringTypes() {
      this.steeringTypes = [
        {
          id: constants.STEERING_TYPE.KHONGPHAICHIDAO,
          name: errorMessageFilter({
            errorCode: "steeringType.label.khongphaichidao"
          })
        },
        {
          id: constants.STEERING_TYPE.CHIDAO,
          name: errorMessageFilter({
            errorCode: "steeringType.label.chidao"
          })
        },
        {
          id: constants.STEERING_TYPE.BAOCAOCHIDAO,
          name: errorMessageFilter({
            errorCode: "steeringType.label.baocaochidao"
          })
        }
      ];
    },

    initValidationRules(mode) {
      let defaultRequiredConstrains = {
        required: true,
        message: "Trường dữ liệu bắt buộc",
        trigger: "blur"
      };

      Vue.set(this.validationRules, "quote", [
        defaultRequiredConstrains,
        {
          max: 2000,
          message: "Không vượt quá 2000 kí tự",
          trigger: "blur"
        }
      ]);
      Vue.set(this.validationRules, "attachment", [defaultRequiredConstrains]);
      Vue.set(this.validationRules, "publisherId", [defaultRequiredConstrains]);
      Vue.set(
        this.validationRules,
        "flowId",
        mode === constants.CREATE_DOCIN_PAGE.MODE.FOR_FORWARD_NEXT_HANDLER &&
        !this.isDongtrinh
          ? [defaultRequiredConstrains]
          : null
      );

      Vue.set(
        this.validationRules,
        "handlerId",
        mode === constants.CREATE_DOCIN_PAGE.MODE.FOR_FORWARD_NEXT_HANDLER &&
        !this.isDongtrinh
          ? [defaultRequiredConstrains]
          : null
      );

      Vue.set(
        this.validationRules,
        "steeringTypeId",
        this.isBanHanhTrucLienThong ? [defaultRequiredConstrains] : null
      );
    },

    // Load ra list departments sau đó load ra list departments nơi nhận bên trong
    loadDepartments() {
      return departmentService
        .findAll({sort: "deptName,asc", status: constants.DEPARTMENT.STATUS.ACTIVE})
        .then(response => {
          this.departments = response.data;
          // Load ra list departments nơi nhận bên trong
          this.prepareReceiveDepartments(this.form ? this.form.publisherId : null);
        });
    },

    saveDoc() {
      this.initValidationRules(constants.CREATE_DOCIN_PAGE.MODE.FOR_SAVE);
      this.$refs.form.clearValidate();
      this.$nextTick(() => {
        this.validateForm().then(() => {
          this.validateVbOpinionForms()
            .then(() => {
              this.isProcessing = true;
              return outgoingDocService.lanhDaoEditOutgoingDoc(this.convertToSubmitForm());
            })
            .then(() => {
              this.isProcessing = false;
              this.message(
                "Thông báo",
                this.id ? "Cập nhật dự thảo thành công" : "Lưu dự thảo thành công",
                "success",
                2000
              );
              EventBus.$emit('loadCounting', '');
              EventBus.$emit(this.parentRoute, {});
              this.backListPage();
            })
            .catch(error => {
              this.isProcessing = false;
              this.commonHandleRequestError(error);
              throw error;
            });
        });
      });
    },

    validateForm() {
      return new Promise(resolve => {
        this.$refs.form.validate(valid => {
          if (valid) {
            resolve();
          } else {
            this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 2000);
          }
        });
      })
      .then(() => this.validateVbOpinionForms());
    },

    validateVbOpinionForms() {
      return new Promise(resolve => {
        if (!this.showTTrTable || this.$refs.phieuYKienForm.validate()) {
          resolve();
        } else {
          this.notify("Lỗi", "Bạn chưa tải đủ phiếu ý kiến.", "error", 2000);
        }
      });
    },

    convertToSubmitForm() {
      let attachIds = [];
      //this.form.attachmentId && attachIds.push(this.form.attachmentId);
      let vbAttachmentDocx = (this.vbAttachmentDocx) ?  this.vbAttachmentDocx.id : null;
      let vbAttachmentPdf = (this.vbAttachmentPdf) ?  this.vbAttachmentPdf.id : null;
      if(vbAttachmentDocx) {
        attachIds.push(vbAttachmentDocx);
      }
      if(vbAttachmentPdf) {
        attachIds.push(vbAttachmentPdf);
      }
      let docRelations = [];
      docRelations.push(
        ...(this.$refs.noAttachedDocRelationsForm.getRelationDocs() || [])
      );
      docRelations.push(
        ...(this.$refs.attachedDocRelationsForm.getRelationDocs() || [])
      );

      let isDocRelationsChange = utils.compareList(this.originalDocRelations, docRelations);
      let vbOpinionForms = [];
      if (this.showTTrTable) {
        vbOpinionForms.push(
          ...(this.$refs.phieuYKienForm.getVbOpinionForms() || [])
        );
      }

      return {
        vbAttachmentDocx: vbAttachmentDocx,
        vbAttachmentPdf: vbAttachmentPdf,
        docId: this.id,
        isDocRelationsChange: isDocRelationsChange,
        quote: this.form.quote,
        docTypeId: this.form.docTypeId,
        docDate: this.form.docDate,
        deadlineDate: this.form.deadlineDate,
        securityId: this.form.securityId,
        priorityId: this.priority ? this.priority.id : null,
        numberOfPage: this.form.numberOfPage,
        attachIds: attachIds,
        outgoingDocReceivers: this.outgoingDocReceivers,
        docRelation: docRelations,
        deptId: this.deptId,
        otherDepartments: this.otherReceiverPlace,
        publisherId: this.form.publisherId,
        tltvbAgencyIds: this.isEnableBanHanhTrucLienThong
          ? this.form.tltvbAgencyIds
          : null,
        isLawDocument: this.form.isLawDocument
          ? constants.TRUE
          : constants.FALSE,
        steeringTypeId: this.form.steeringTypeId,
        vbOpinionForms: vbOpinionForms,
        eFlag: constants.VB_OUTGOING_DOC.EFLAG.TRUE
      };
    },

    prepareFormForEditMode() {
      return Promise.all([
        outgoingDocService.findById(this.id).then(response => response.data),
        this.loadReceiveDeparts(constants.RECEIVER_OBJECT_TYPE.DONVI),
        this.loadReceiveDeparts(constants.RECEIVER_OBJECT_TYPE.DONVI_BENNGOAI),
        this.loadReceiveDeparts(constants.RECEIVER_OBJECT_TYPE.DONVI_TRUCLIENTHONG)
      ]).then(results => {
        this.outgoingDoc = results[0];
        this.showTTrTable = this.isToTrinhOrGiaiTrinh(
          this.outgoingDoc.docTypeCode
        );
        let receiveDepts = results[1];
        let receiveOtherDepts = results[2];
        let receiveAgencies = results[3];

        this.form.quote = this.outgoingDoc.quote;
        this.form.docTypeId = this.outgoingDoc.docTypeId;
        this.form.docDate = this.outgoingDoc.docDate;
        this.form.deadlineDate = this.outgoingDoc.deadlineDate;
        this.form.securityId = this.outgoingDoc.securityId;
        this.form.numberOfCopy = this.outgoingDoc.numberOfCopy;
        this.form.numberOfPage = this.outgoingDoc.numberOfPage;
        this.form.publisherId = this.outgoingDoc.publisherId;
        this.form.publisherName = this.outgoingDoc.publisherName;
        this.form.isLawDocument = this.outgoingDoc.isLawDocument === constants.TRUE;
        this.form.steeringTypeId = this.outgoingDoc.steeringType;
        this.form.priorityId = this.outgoingDoc.priorityId;
        if(this.outgoingDoc.priorityId) {
          this.priority = this.priorities.find(
            item => item.id === this.outgoingDoc.priorityId
          );
        }
        this.originalDocRelations.push(
          ...(this.$refs.noAttachedDocRelationsForm.getRelationDocs() || [])
        );
        this.originalDocRelations.push(
          ...(this.$refs.attachedDocRelationsForm.getRelationDocs() || [])
        );

        this.docDate = this.outgoingDoc.docDate
          ? dateUtils.toMoment(this.outgoingDoc.docDate).toDate()
          : null;
        this.form.deadlineDate = this.outgoingDoc.deadlineDate
          ? dateUtils.toMoment(this.outgoingDoc.deadlineDate).toDate()
          : null;

        // Get ra danh sách phòng ban - nơi nhận bên trong
        this.prepareReceiveDepartments(this.form.publisherId);

        this.form.receiveDepartmentIds = h.collect(receiveDepts, item => item.objectId);
        this.otherReceiverPlace = h.collect(receiveOtherDepts, item => item.objectName) || [];

        this.form.tltvbAgencyIds = h.collect(
          receiveAgencies,
          item => item.objectId
        );

        this.loadUserVbOutgoingProcess();
        this.loadDepartments(); // Load ra list departments sau đó load ra list departments nơi nhận bên trong
        // this.loadCategory();
        // this.loadFlows();
        // this.loadVbFlowInstance();
        // this.maskAsRead();
        // this.loadSelectedAgencies();
      }).then(() => {
        outgoingDocVersionService.findAllByDocId(this.id).then(response => {
          this.docVersions = response.data;
        }).then((result) => {
          this.loadAttachment();
        });
      });
    },

    loadAttachment() {
      return attachmentService
        .findAllByVbOutgoingDoc({
          objectId: this.id,
          objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DI,
        })
        .then(response => {
          if (response.data && response.data.length) {
            let activeVersion = this.docVersions.filter(item => item.isActive === constants.VB_BOOK_DOC_TYPE.STATUS.ACTIVE)[0]
            this.vbAttachmentPdf = response.data.filter(item => item.fileServiceId === activeVersion.pdfAttachDocumentId)[0];
            this.vbAttachmentDocx = response.data.filter(item => item.fileServiceId === activeVersion.docAttachDocumentId)[0];
            if(this.vbAttachmentDocx)
            {
              this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "editWordForLD" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachmentDocx.id;
            }
            //this.form.attachmentId = this.vbAttachmentDocx.id;
          }
        }).then(() => {
            // this.loadAttachDocumentVersion();
          }
        );
    },

    loadReceiveDeparts(receiverObjectType) {
      return outgoingDocReceiversService
        .findAll({docId: this.id, objectType: receiverObjectType})
        .then(response => response.data);
    },

    isToTrinhOrGiaiTrinh(docTypeCode) {
      return (
        docTypeCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_HDTV ||
        docTypeCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_BTVDU ||
        docTypeCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_BKTDU ||
        docTypeCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_HDTDKT ||
        docTypeCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_BTVDU ||
        docTypeCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_BKTDU ||
        docTypeCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_HDTV ||
        docTypeCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_HDTDKT
      );
    },

    remoteMethod(query) {
      return this.findOtherDept(query).then(
        otherDepartments => (this.listOtherReceiverPlace = otherDepartments)
      );
    },

    findOtherDept(query) {
      query = query.trim();
      this.isLoading = true;
      return (query
          ? otherDepartmentService
            .search(query, this.deptId, {
              sort: "count,desc",
              page: 0,
              size: 20
            })
            .then(response => response.data)
          : Promise.resolve([])
      ).then(otherDepartments => {
        this.isLoading = false;
        return otherDepartments;
      });
    },

    publisherDepartmentChange(event) {
      let departmentIds = h.collect(
        event.selectedDepartments,
        department => department.id
      );

      if (departmentIds) this.form.receiveDepartmentIds = departmentIds;

      this.isOpenSelectDepartmentDialog = false;
    },

    loadPublisherDepartments() {
      departmentService.findParents(this.deptId).then(response => {
        this.publisherDepartments = response.data;
      });
    },

    publisherIdChange() {
      // this.$refs["form"].validateField("publisherId");
      //reset lại nơi nhận bên trong;
      this.form.receiveDepartmentIds = [];
      this.prepareReceiveDepartments(this.form.publisherId);
      if (!this.isDongtrinh) {
        (!this.form.publisherId
            ? new Promise((resolve) => {
              this.flows = [];
              resolve();
            })
            : this.loadFlows()
        ).then(() => {
          //trong TH chọn tờ trình => default chọn luồng hội trinh ky ban TGĐ;
          this.flowIdChange(
            (this.form.flow = this.showTTrTable
              ? h.find(
                this.flows,
                flow =>
                  flow.flowCode ===
                  constants.VB_FLOW.FLOW_CODE.LUONG_TRINH_BAN_TGD
              )
              : null)
          );
        });
      }

      //reset lại đơn vị trên trục;
      if (
        !this.isEnableBanHanhTrucLienThong &&
        this.form.tltvbAgencyIds &&
        this.form.tltvbAgencyIds.length
      ) {
        this.form.tltvbAgencyIds = [];
        this.tltvbAgencyIdsChanged();
      }
    },

    // Get ra danh sách phòng ban - nơi nhận bên trong
    prepareReceiveDepartments(publisherId) {
      this.receiveDepartments = departmentService.prepareReceiveDepartments(
        publisherId,
        this.departments
      );
    },

    loadFlows() {
      return flowService
        .findAll({
          deptId: this.form.publisherId,
          flowType: constants.FLOW_TYPE.VB_DI
        })
        .then(response => {
          this.flows = response.data;
          //set default
          this.flowIdChange(
            h.find(
              this.flows,
              item => item.isDefault === constants.VB_FLOW.DEFAULT.IS_DEFAULT
            )
          );
        });
    },

    flowIdChange(flow) {
      this.form.flow = flow;
      this.form.flowId = flow ? flow.id : null;
      this.validateFields();
      this.loadNextStep();
    },

    validateFields() {
      this.$nextTick(() => {
        this.$refs["form"].validateField("flowId");
        this.$refs["form"].validateField("handlerId");
      });
    },

    loadNextStep() {
      this.handler = null;
      this.handlers = [];
      if (this.flowId) {
        nextStepInfoViewService.nextSteps(this.flowId, null).then(response => {
          this.nextSteps = response.data;
          h.each(this.nextSteps, item => this.loadUsersForNextStep(item));
        });
      } else {
        this.nextSteps = [];
      }
    },

    loadUsersForNextStep(nextStep) {
      userDeptRoleViewService
        .findAllActiveForStepInfo(nextStep.vbStepInfoId)
        .then(response => {
          let users = this.filterHanlders(response.data);
          this.handlers = this.handlers.concat(
            h.collect(users, userView => {
              return {
                id: userView.id,
                userView: userView,
                stepId: nextStep.id
              };
            })
          );
        });
    },

    filterHanlders(resData) {
      return resData.filter(
        item =>
          item.roleCode !== "lanhdao" ||
          (item.status === constants.USER_DEPT_ROLE.STATUS.ACTIVE &&
            (item.deptId === this.userDeptRole.deptId ||
              item.deptId === this.userDeptRole.parentDeptId))
      );
    },

    docTypeChange() {
      if (this.form.docTypeId) {
        let docType = this.docTypes.find(
          type => type.id === this.form.docTypeId
        );
        this.showTTrTable =
          docType && this.isToTrinhOrGiaiTrinh(docType.categoryCode);
        let deptPublishedId = this.showTTrTable ? this.publisherDepartments.find(
          dept => (dept.deptCode === this.$store.getters.globalRoles)
        ) : null;
        if (docType.categoryCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_BTVDU
          || docType.categoryCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_BKTDU
          || docType.categoryCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_BTVDU
          || docType.categoryCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_BKTDU
        ) {
          deptPublishedId = this.showTTrTable ? this.publisherDepartments.find(
            dept => (dept.deptCode === this.userDeptRole.deptCode)
          ) : null;
        } else if (docType.categoryCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_HDTDKT
          || docType.categoryCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_HDTDKT) {
          deptPublishedId = this.showTTrTable ? this.publisherDepartments.find(
            dept => (dept.deptCode === constants.TCCB_DEPT_CODE)
          ) : null;
        }
        console.log('deptPublishedId', deptPublishedId);
        this.categoryCode = docType.categoryCode;
        this.form.publisherId = deptPublishedId ? deptPublishedId.id : null;
        this.publisherIdChange();
      }
    },

    openCreateTemplateFile() {
      this.isOpenAttachDocumentDialog = true
      this.isCreateTemplateFile = true
    },

    buildMessageUploadOnlyPdf() {
      return errorMessageFilter({errorCode: "file.onlyAllowDocOutType"});
    },

    onUploadError() {
      this.isUploading = false;
      this.$message({
        message: errorMessageFilter({errorCode: "file.uploadFail"}),
        type: "error"
      });
    },

    onUploadSuccess(response) {
      this.isUploading = false;
      return new Promise(resolve => resolve(response));
    },

    uploadAttachmentSuccess(vbAttachment) {
      vbAttachment.fileExtention === "pdf"
        ?  this.vbAttachmentPdf = vbAttachment
        :  this.vbAttachmentDocx = vbAttachment;
      //this.form.attachmentId = vbAttachment.id;
      this.form.numberOfPage = vbAttachment.pageNumber;
      if(this.vbAttachmentDocx)
      {
        this.wordEditSrc = constants.EDIT_ONLINE_SERVICE_URL + "editWordForLD" + "?tenantCode=" + this.$store.getters.user.tenantCode + "&attachmentId=" + this.vbAttachmentDocx.id;
      }
    },

    newValidateUploadFile(file, options, messageErr) {
      !options && (options = {});

      let fileExt = utils.getFileExt(file);

      //validate file type;
      let type = file.type;
      let acceptFileTypes = options.acceptFileTypes;
      if (!acceptFileTypes || !acceptFileTypes.length) {
        acceptFileTypes = constants.DEFAULT_ACCEPTED_CONTENT_TYPE;
      }
      let blackListExtensions =
        options.blackListExtensions || constants.DEFAULT_BLACK_LIST_EXTS;
      if (
        (acceptFileTypes.indexOf(type) === -1 &&
          acceptFileTypes.indexOf(
            constants.DEFAULT_ACCEPTED_CONTENT_TYPE_ALL
          ) === -1) ||
        blackListExtensions.indexOf(fileExt) !== -1
      ) {
        this.$message({
          message:
            messageErr ||
            errorMessageFilter({
              errorCode: "file.invalidFileType"
            }),
          type: "error"
        });
        return false;
      }

      //validate file size;
      let size = file.size;
      let maxFileSize = options.acceptFileSize;
      !maxFileSize && (maxFileSize = constants.DEFAULT_MAX_FILE_SIZE_MB);
      if (size > maxFileSize * 1024 * 1024) {
        this.$message({
          message: errorMessageFilter({
            errorCode: "file.invalidFileSize",
            params: [maxFileSize]
          }),
          type: "error"
        });
        return false;
      }
      this.isUploading = true;
      return true;
    },

    inPhieuTrinhKi(item) {
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.VB_DI;
      console.log('docId', this.id)
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize({docId: this.id})}`,
      );
    },
    linkFolder() {
      this.isEnableCreateDialog = true;
      this.isOpenDialogCreate = true
      this.isEnableTreeFolderDialog = true
    },
    suaSaiSuccess(event) {
      this.isOpenSuaSaiDialog = false;
      this.backListPage();

      EventBus.$emit(this.parentRoute, {});
    },
    permanentDelete() {
      utils
        .confirm(
          this.$confirm,
          errorMessageFilter({
            errorCode: "vbOutgoingDoc.permanentDelete.confirm"
          })
        )
        .then(() => {
          return outgoingDocService.permanentDelete(this.id).then(() => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "vbOutgoingDoc.permanentDelete.success"
              })
            );
            this.commonAfterSuccess();
          });
        })
        .catch(error => this.commonHandleRequestError(error));
    },

    restore() {
      utils
        .confirm(
          this.$confirm,
          errorMessageFilter({
            errorCode: "vbOutgoingDoc.restore.confirm"
          })
        )
        .then(() => {
          return outgoingDocService.restore(this.id).then(() => {
            this.$message.success(
              errorMessageFilter({
                errorCode: "vbOutgoingDoc.restore.success"
              })
            );
            this.commonAfterSuccess();
          });
        })
        .catch(error => this.commonHandleRequestError(error));
    },

    openKetThucDialog(){
      this.initValidationRules(constants.CREATE_DOCIN_PAGE.MODE.FOR_SAVE);
      this.$refs.form.clearValidate();
      this.$nextTick(() => {
        this.validateForm().then(() => {
          this.validateVbOpinionForms()
            .then(() => {
              this.isProcessing = true;
              return outgoingDocService.lanhDaoEditOutgoingDoc(this.convertToSubmitForm());
            })
            .then(() => {
              this.isProcessing = false;
              this.message(
                "Thông báo",
                this.id ? "Cập nhật dự thảo thành công" : "Lưu dự thảo thành công",
                "success",
                2000
              );
            }).then(() => {
            this.isOpenDocOutKetThucDialog = true
          })
            .catch(error => {
              this.isProcessing = false;
              this.commonHandleRequestError(error);
              throw error;
            });
        });
      });
    },

    initSteeringTypeLabel() {
      switch (this.outgoingDoc.steeringType) {
        case constants.STEERING_TYPE.KHONGPHAICHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.khongphaichidao"
          });
          break;
        case constants.STEERING_TYPE.CHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.chidao"
          });
          break;
        case constants.STEERING_TYPE.BAOCAOCHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.baocaochidao"
          });
          break;
      }
    },

    delete_() {
      this.$confirm(
        `Bạn có muốn xóa văn bản "${this.outgoingDoc.quote}" ?`,
        "Thông báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning"
        }
      ).then(() => {
        outgoingDocService
          .deleteForVanThu(this.id)
          .then(() => {
            this.$message({
              message: "Xóa văn bản thành công",
              type: "success"
            });
            EventBus.$emit('loadCounting', '');
            this.commonAfterSuccess();
          })
          .catch(error => this.commonHandleRequestError(error));
      });
    },
    exportTiepNhanVanBanReport() {
      utils.exportReport(constants.REPORT.TIEPNHANVANBAN.REPORT_URL, {
        userDeptRoleId: this.userDeptRoleId,
        docId: this.id,
        docType: constants.DOC_TYPE.VB_DI
      });
    },

    // initForGiaoViecButton() {
    //   return menuConfigService
    //     .findAll({
    //       userDeptRoleId: this.userDeptRoleId,
    //       menuCode: constants.MENU_LIST.CONGVIEC_GIAO,
    //       status: constants.MENU_CONFIG.STATUS.ACTIVE
    //     })
    //     .then(response => {
    //       let menuConfigs = response.data;
    //       return (this.giaoViecMenuConfig =
    //         menuConfigs && menuConfigs.length ? menuConfigs[0] : null);
    //     });
    // },

    createTaskSuccess() {
      this.isOpenCreateJobDialog = false;
    },

    openGiaoViecDialog() {
      this.isOpenCreateJobDialog = true;
    },

    loadAttachmentMetadata() {
      if (this.vbAttachmentPdf && this.vbAttachmentPdf.id) {
        attachmentService
          .getAttachmentMetadata(this.vbAttachmentPdf.id)
          .then(response => {
            this.attachmentMetadata = response.data;
          });
      } else {
        this.attachmentMetadata = null;
      }
    },

    // Load văn bản thể hiện
    // loadReferenceOutgoingAttachment() {
    //   attachmentService
    //     .findReferenceOutgoingAttachment(this.id)
    //     .then(response => (this.referenceOutgoingAttachment = response.data));
    // },

    /**
     * link download cho chuyen vien sau khi ban hanh;
     */
    buildReferenceOutgoingAttachmentURL() {
      if (this.referenceOutgoingAttachment) {
        vbAttachmentTokenService
          .getTokenForReferenceOutgoingAttachment(
            this.referenceOutgoingAttachment.id
          )
          .then(response => {
            let token = response.data.token;
            this.referenceOutgoingAttachmentURL = buildAttachmentURL(token, {
              downloadFileURL:
              constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL
            });
          });
      } else {
        this.referenceOutgoingAttachmentURL = null;
      }
    },

    buildReferenceOutgoingAttachmentURL2() {
      if (this.vbAttachmentPdf) {
        vbAttachmentTokenService
          .getToken(this.vbAttachmentPdf.id)
          .then(response => {
            let token = response.data.token;
            this.referenceOutgoingAttachmentURL2 = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.PDF,
              downloadFileURL: constants.DOWNLOAD_FILE_URL.OUTGOING_URL
            });
          });
      } else {
        this.referenceOutgoingAttachmentURL2 = null;
      }
    },

    /**
     * link download khong co watermark;
     */
    buildOutgoingAttachmentForVanThuURL() {
      if (this.referenceOutgoingAttachment) {
        vbAttachmentTokenService
          .getTokenForReferenceOutgoingAttachment(
            this.referenceOutgoingAttachment.id
          )
          .then(response => {
            let token = response.data.token;
            this.outgoingAttachmentForVanThuURL = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL,
              downloadFileURL: constants.DOWNLOAD_FILE_URL.DEFAULT_URL
            });
          });
      } else {
        this.outgoingAttachmentForVanThuURL = null;
      }
    },

    /**
     * link download nguyen goc;
     */
    buildOutgoingAttachmentURL() {
      if (this.vbAttachmentPdf) {
        vbAttachmentTokenService
          .getToken(this.vbAttachmentPdf.id)
          .then(response => {
            let token = response.data.token;
            this.outgoingAttachmentURL = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL,
              downloadFileURL: constants.DOWNLOAD_FILE_URL.DEFAULT_URL
            });
          });
      } else {
        this.outgoingAttachmentURL = null;
      }
    },

    addSignatureSuccess() {
      this.isOpenAddSignatureDialog = false;
      this.prepareFormForEditMode();
      // this.loadReferenceOutgoingAttachment();
    },

    populateListImageDoc(listImage) {
      let listImageModify = [];
      h.each(listImage, item => {
        if (item.isModify) {
          listImageModify.push({
            base64: item.base64,
            pageNumber: item.id,
            vbAttachmentId: this.vbAttachmentPdf.id
          });
        }
      });
      return listImageModify;
    },

    finishNoteDoc(listImage) {
      this.listImageChange = this.populateListImageDoc(listImage);
      this.tuChoi();
    },

    hieuChinhVb() {
      this.$router.push({
        name: "vbChoBanHanhHieuChinh",
        params: {
          userDeptRoleId: this.$route.params.userDeptRoleId,
          id: this.id
        },
        query: this.$route.query
      });
    },

    suaSaiBanHanh() {
      this.isOpenSuaSaiDialog = true;
    },

    loadVbFlowInstance() {
      vbFlowInstanceService
        .findAll(
          {docId: this.id},
          {page: 0, size: 10, sort: "updateTime,asc"}
        )
        .then(response => {
          this.flowInstances = response.data.map((item, index) => {
            return {
              id: item.id,
              updateTime: item.updateTime,
              isActive: index == response.data.length - 1
            };
          });
        });
    },

    outGoingProcessThuHoiSuccess() {
      this.isOpenOutgoingDocProcessThuHoiDialog = false;
    },

    openTabHistory() {
      this.tabHistory = true;
    },

    closeTabHistory() {
      this.tabHistory = false;
    },

    // Khởi tạo list độ khẩn, loại văn bản, ...
    loadCategories() {
      h.each([
          constants.CATEGORY_GROUP_CODE.PRIORITY,
          constants.CATEGORY_GROUP_CODE.DOC_TYPE,
          constants.CATEGORY_GROUP_CODE.SECRET_LEVEL
        ],

        item => {
          categoryViewService
            .findAll(
              {groupCode: item},
              {sort: "order,asc", page: 0, size: 1000}
            )
            .then(response => {
              switch (item) {
                case constants.CATEGORY_GROUP_CODE.PRIORITY:
                  // set default
                  this.priority = h.find(
                    response.data,
                    priority =>
                      priority.categoryCode === "BT" ||
                      priority.categoryName.toUpperCase() === "BÌNH THƯỜNG"
                  );
                  return (this.priorities = response.data);

                case constants.CATEGORY_GROUP_CODE.DOC_TYPE:
                  return (this.docTypes = response.data);

                case constants.CATEGORY_GROUP_CODE.SECRET_LEVEL:
                  return (this.secretLevels = response.data);
              }
            });
        }
      );
    },

    customLabelPriority(option) {
      return `${option.categoryName} `;
    },

    openCCDialog() {
      this.isOpenDocOutCCDialog = true;
    },

    tuChoi() {
      this.isOpenDocOutTuChoiDialog = true;
    },

    tuChoiBHanh() {
      this.isOpenDocOutTuChoiBHanhDialog = true;
    },

    banHanhSuccess(event) {
      this.isOpenDocOutKetThucDialog = false;
      this.userVbOutgoingProcess = event.vbOutgoingProcess;
      this.backListPage();
      EventBus.$emit(this.parentRoute, {});
    },

    tuChoiSuccess() {
      this.isOpenDocOutTuChoiDialog = false;
      this.isOpenNoteInDocDialog = false;
      this.backListPage();
      EventBus.$emit(this.parentRoute, {});
    },

    tuChoiBHanhSuccess() {
      this.isOpenDocOutTuChoiBHanhDialog = false;
      this.backListPage();
      EventBus.$emit(this.parentRoute, {});
    },

    banHanhVanThuSuccess() {
      this.isOpenBHanhDocOut = false;
      this.commonAfterSuccess();
    },

    ccSuccess() {
      this.isOpenDocOutCCDialog = false;
      this.backListPage();
      this.commonAfterSuccess();
    },

    commonAfterSuccess() {

      EventBus.$emit(this.parentRoute, {});
      this.backListPage();
    },

    docOutKetThucDialogClosed() {
      if (this.isBanHanhSuccess) {
        this.message(
          "Thông báo",
          "Ban hành văn bản thành công.",
          "success",
          4000
        );

        this.backListPage();

        this.prepareFormForEditMode();


        EventBus.$emit(this.parentRoute, {});
      }
    },

    docOutTuChoiDialogClosed() {
      if (this.isTuChoiSuccess) {
        this.message(
          "Thông báo",
          "Từ chối văn bản thành công.",
          "success",
          3000
        );

        this.backListPage();

        this.prepareFormForEditMode();


        EventBus.$emit(this.parentRoute, {});
      }
    },

    isEnableChuyenXuLi() {
      return (
        this.isChoXuLy() &&
        this.step &&
        this.step.posType != constants.STEP_POS_TYPE.KET_THUC &&
        this.step.posType != constants.STEP_POS_TYPE.BOTH
      );
    },

    isTuChoi() {
      return this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.TU_CHOI;
    },

    isChoXuLy() {
      return (
        this.userVbOutgoingProcess &&
        this.userVbOutgoingProcess.status ==
        constants.OUTGOING_PROCESS_STATUS.CHO_XU_LY
      );
    },

    isTaoMoi() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.TAOMOI
      );
    },

    isEnableKetThuc() {
      return (
        this.isChoXuLy() &&
        this.step &&
        (this.step.posType == constants.STEP_POS_TYPE.KET_THUC ||
          this.step.posType == constants.STEP_POS_TYPE.BOTH)
      );
    },
    isEnableThuHoi() {
      return (
        this.isChoXuLy() &&
        this.step &&
        (this.step.posType == constants.STEP_POS_TYPE.KET_THUC ||
          this.step.posType == constants.STEP_POS_TYPE.BOTH)
      );
    },

    isEnableBanHanh() {
      return (
        this.roleCode == "vanthu" &&
        this.outgoingDoc &&
        (this.outgoingDoc.status ==
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH)
      );
    },
    isEnableTuChoiBanHanh() {
      return (
        this.flowInstances.length &&
        this.roleCode == "vanthu" &&
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH
      );
    },

    isEnableHieuChinh() {
      return (
        this.roleCode == "vanthu" &&
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH
      );
    },

    isEnableSuaSaiBanHanh() {
      return (
        this.roleCode == "vanthu" &&
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH
      );
    },

    isEnableThemChuKy() {
      return (
        this.roleCode == "vanthu" &&
        this.attachmentMetadata &&
        this.outgoingDoc &&
        (this.outgoingDoc.status ==
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH)
      );
    },
    isEnableDelete() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.isKyNgoai == constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH &&
        this.outgoingDoc.publisherId ==
        this.$store.getters.userDeptRole.deptId &&
        this.$store.getters.userDeptRole.roleCode == constants.ROLE.CODE.VAN_THU
      );
    },

    isEnableCC() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH
      );
    },

    chuyenXuLiSuccess() {
      this.isOpenDocOutSelectHandlerDialog = false;

      this.message(
        "Thông báo",
        this.step && this.step.signType == 2
          ? "Ký số và chuyển xử lý văn bản thành công "
          : "Chuyển xử lý văn bản thành công ",
        "success",
        4000
      );


      EventBus.$emit(this.parentRoute, {});
      this.backListPage();
    },

    loadDocReceivers_(objectType) {
      return vbOutgoingDocReceiversService
        .findAll(
          {docId: this.id, objectType: objectType},
          {sort: "objectType", page: 0, size: 1000}
        )
        .then(response => response.data);
    },

    loadDocReceivers() {
      return this.loadDocReceivers_(constants.RECEIVER_OBJECT_TYPE.DONVI).then(
        docReceivers => {
          this.docReceivers = docReceivers;
          this.docReceiverIds = h.collect(
            docReceivers,
            docReceiver => docReceiver.objectId
          );
        }
      );
    },

    loadAgencies() {
      return this.loadDocReceivers_(
        constants.RECEIVER_OBJECT_TYPE.DONVI_TRUCLIENTHONG
      ).then(agencies => (this.agencies = agencies));
    },

    loadReceiveOtherDepts() {
      return this.loadDocReceivers_(
        constants.RECEIVER_OBJECT_TYPE.DONVI_BENNGOAI
      ).then(docReceivers => (this.receiveOtherDepts = docReceivers));
    },

    loadUserVbOutgoingProcess() {
      if (this.userVbOutgoingProcessId) {
        vbOutgoingProcessService.findById(this.userVbOutgoingProcessId)
          .then(response => {
            this.userVbOutgoingProcess = response.data;
            this.flowInstanceId = this.userVbOutgoingProcess.flowInstanceId;
            this.stepId = this.userVbOutgoingProcess.stepId;

            vbStepService.findById(this.stepId)
              .then(response => (this.step = response.data));

            if (this.userVbOutgoingProcess.delegateInfoId) {
              vbDelegateInfoService.findById(this.userVbOutgoingProcess.delegateInfoId)
                .then(response => (this.delegateInfo = response.data));
            } else {
              this.delegateInfo = null;
            }

            vbFlowInstanceService.findById(this.flowInstanceId)
              .then(response => {
                this.flowInstance = response.data;
                this.flowId = this.flowInstance.flowId;
              });
            // this.markAsRead();
          });
      }
    },

    modelBack() {
      this.$router.back();
    },

    getSecurityClass(id) {
      return constants.HIGH_LEVELS_SECURITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    getPriorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    // backListPage() {
    //   this.$router.push({name: this.parentRoute, params: this.$route.params});
    // },

    maskAsRead() {
      outgoingDocService
        .maskAsRead(this.id, this.userVbOutgoingProcessId)
        .catch(error => this.commonHandleRequestError(error));
    },

    backListPage() {
      this.$router.push({
        name: "vbDuThaoNew"
      });
    },
    createSuccess() {
      this.isOpenDialogCreate = false;
    },
    closeCreateDialog() {
      this.isOpenDialogCreate = false;
    },
    closeTreeFolderDialog() {
      this.isEnableTreeFolderDialog = false
    },

    openChuyenXuLyLuongMoiDialog()
    {
      this.initValidationRules(constants.CREATE_DOCIN_PAGE.MODE.FOR_SAVE);
      this.$refs.form.clearValidate();
      this.$nextTick(() => {
        this.validateForm().then(() => {
          this.validateVbOpinionForms()
            .then(() => {
              this.isProcessing = true;
              return outgoingDocService.lanhDaoEditOutgoingDoc(this.convertToSubmitForm());
            })
            .then(() => {
              this.isProcessing = false;
              this.message(
                "Thông báo",
                this.id ? "Cập nhật dự thảo thành công" : "Lưu dự thảo thành công",
                "success",
                2000
              );
            }).then(() => {
            this.isOpenDocOutSelectHandlerDialog = true;
          })
            .catch(error => {
              this.isProcessing = false;
              this.commonHandleRequestError(error);
              throw error;
            });
        });
      });
    },

    removeUploadAttachment() {
      console.log("removeUploadAttachment");
      this.vbAttachmentPdf = null;
      this.form.attachmentFiles = [];
    },

    removeUploadAttachmentDocx() {
      console.log("removeUploadAttachmentDocx");
      this.vbAttachmentDocx = null;
      this.wordEditSrc = null;
      this.form.attachmentFiles = [];
    },

    customDeptName(department) {
      return `${department.deptName} - ${department.deptCode} (${
        department.parentName
      })`;
    },
  },

  destroyed() {
    EventBus.$off("hieuChinhSuccess");
    document.removeEventListener("keyup", this.escapeKeyListener);
  }
};
</script>

<style scoped>
.overflow-menu {
  position: relative;

  overflow-x: scroll;
  top: 4px;
  padding: 3px;
  margin: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/docOutLanhDaoEdit.vue